// Mock data for Smart Systems Paraguay - SMARTMICRO Traffic Sensors

export const companyInfo = {
  name: "Smart Systems Paraguay SA",
  address: "Calle San Juan XXIII N° 1128 casi San Rafael, Barrio Carmelitas - Asunción",
  whatsapp: "+595994349687",
  email: "contacto@smartsystemsparaguay.com",
  brand: "SMARTMICRO"
};

export const heroContent = {
  title: "Capteurs Radar Intelligents",
  subtitle: "pour la Gestion du Trafic",
  description: "Découvrez la technologie de détection radar la plus avancée au monde pour optimiser le flux de circulation, améliorer la sécurité routière et construire des villes plus intelligentes.",
  cta: "Demander une démonstration"
};

export const advantages = [
  {
    id: 1,
    icon: "CloudRain",
    title: "Fiabilité Tous Temps",
    description: "Fonctionne parfaitement sous la pluie, la neige, le brouillard, de jour comme de nuit. La technologie radar n'est pas affectée par la saleté, le smog ou les tempêtes de sable."
  },
  {
    id: 2,
    icon: "Shield",
    title: "Protection de la Vie Privée",
    description: "Contrairement aux caméras, les capteurs radar ne capturent ni visages ni plaques d'immatriculation, garantissant une confidentialité totale des usagers de la route."
  },
  {
    id: 3,
    icon: "Zap",
    title: "Installation Simple",
    description: "Montage non-intrusif sur l'infrastructure existante : poteaux d'éclairage, feux de circulation. Aucune modification de la chaussée nécessaire."
  },
  {
    id: 4,
    icon: "Target",
    title: "Précision Ultra-Haute",
    description: "Technologie 4D/UHD permettant de classifier 7 types de véhicules avec une précision de détection supérieure à 98%."
  },
  {
    id: 5,
    icon: "Timer",
    title: "Données en Temps Réel",
    description: "Transmission instantanée des données de trafic pour une gestion adaptative et des décisions immédiates."
  },
  {
    id: 6,
    icon: "Leaf",
    title: "Réduction CO2",
    description: "Optimisation du flux de circulation réduisant les embouteillages et les temps d'attente, contribuant à la diminution des émissions."
  }
];

export const applications = [
  {
    id: 1,
    icon: "TrafficCone",
    title: "Gestion des Intersections",
    description: "Un seul capteur pour la détection à la ligne d'arrêt et en amont. Estimation de la longueur des files d'attente et contrôle adaptatif des feux.",
    features: [
      "Détection combinée arrêt + avance",
      "Jusqu'à 6 voies couvertes",
      "Protection zone de dilemme",
      "Priorité véhicules d'urgence"
    ]
  },
  {
    id: 2,
    icon: "Route",
    title: "Autoroutes & Voies Rapides",
    description: "Comptage, classification et analyse statistique du trafic. Détection d'incidents et de véhicules à contre-sens.",
    features: [
      "Portée jusqu'à 500m",
      "Classification 7 catégories",
      "Détection contre-sens",
      "Surveillance temps réel"
    ]
  },
  {
    id: 3,
    icon: "Camera",
    title: "Contrôle & Enforcement",
    description: "Solutions certifiées pour le contrôle des feux rouges et de la vitesse, avec une précision de mesure inégalée.",
    features: [
      "Contrôle feux rouges",
      "Radars fixes de vitesse",
      "Radars mobiles",
      "Double mesure redondante"
    ]
  },
  {
    id: 4,
    icon: "Building2",
    title: "Villes Intelligentes",
    description: "Intégration dans les systèmes de gestion urbaine pour optimiser le flux de trafic et améliorer la qualité de vie.",
    features: [
      "Communication V2X",
      "Big Data trafic",
      "Protection piétons/cyclistes",
      "Intégration IoT"
    ]
  }
];

export const products = [
  {
    id: 1,
    name: "TRUGRD® Stream",
    category: "Premium",
    description: "",
    specs: [
      "Solución todo en uno que combina las ventajas del radar y la cámara",
      "Cámara con un rendimiento excepcional en condiciones de baja iluminación",
      "Cobertura de hasta 12 carriles",
      "Alcance de hasta 300 m"
    ],
    image: "https://customer-assets.emergentagent.com/job_smartsystems-py/artifacts/i4b4mp1o_Screenshot_20260104_061046_Samsung%20Notes.jpg",
    datasheet: null
  },
  {
    id: 2,
    name: "TOPGRD",
    category: "Estándar de nueva generación",
    description: "",
    specs: [
      "Seguimiento mejorado: seguimiento con IA de súper resolución",
      "Champ de vision jusqu'à 100°",
      "Portée jusqu'à 240 m",
      "Couvrant jusqu'à 10 voies"
    ],
    image: "https://customer-assets.emergentagent.com/job_smartmicro-1/artifacts/y6t8xo35_Screenshot_20260123_054601_Chrome.jpg",
    datasheet: null
  },
  {
    id: 3,
    name: "COM HUB",
    category: "Conectividad",
    description: "",
    specs: [
      "Soluciones de vanguardia para la conexión de los sensores TOPGRD y TRUGRD a los sistemas de gestión del tráfico",
      "Fusión multisensor (patentada)",
      "Admite los protocolos PLC, LAN/MQTT y VPN",
      "Solución económica y de bajo mantenimiento"
    ],
    image: "https://customer-assets.emergentagent.com/job_smartmicro-1/artifacts/upq77d07_Screenshot_20260123_061949_Chrome.jpg",
    datasheet: null
  }
];

export const statistics = [
  { value: "150 000+", label: "Capteurs déployés" },
  { value: "10+", label: "Années d'expérience" },
  { value: "98.4%", label: "Précision de détection" },
  { value: "24/7", label: "Fonctionnement continu" }
];

export const faqs = [
  {
    question: "Pourquoi choisir la technologie radar plutôt que les caméras ?",
    answer: "Le radar offre plusieurs avantages clés : il fonctionne parfaitement dans toutes les conditions météorologiques (pluie, neige, brouillard), ne nécessite aucun éclairage, respecte totalement la vie privée des usagers car il ne capture ni visages ni plaques, et ne requiert pratiquement aucune maintenance."
  },
  {
    question: "Quelle est la durée de vie des capteurs SMARTMICRO ?",
    answer: "Les capteurs SMARTMICRO sont conçus pour une durée de vie prolongée avec une classification IP67 et une plage de fonctionnement de -40°C à +85°C. Ils intègrent des fonctions d'auto-calibration et d'auto-diagnostic qui maintiennent leur précision tout au long de leur cycle de vie."
  },
  {
    question: "Les capteurs peuvent-ils être installés sur l'infrastructure existante ?",
    answer: "Oui, c'est l'un des grands avantages de la technologie SMARTMICRO. Les capteurs peuvent être montés sur des poteaux d'éclairage existants, des feux de signalisation, des portiques ou en bordure de route, sans aucune modification de la chaussée."
  },
  {
    question: "Combien de voies un seul capteur peut-il couvrir ?",
    answer: "Selon le modèle, un seul capteur SMARTMICRO peut couvrir de 6 à 12 voies simultanément, avec une portée allant jusqu'à 500 mètres pour les modèles longue portée."
  },
  {
    question: "Les capteurs sont-ils certifiés pour le contrôle de vitesse ?",
    answer: "Oui, les capteurs SMARTMICRO sont testés et certifiés par l'Institut Fédéral Suisse de Métrologie (METAS) pour les applications de contrôle de vitesse et de feux rouges."
  }
];

export const whyChoose = [
  {
    icon: "Award",
    title: "Leader Mondial",
    description: "Plus de 150 000 capteurs déployés dans le monde, faisant de SMARTMICRO le leader incontesté de la détection radar de trafic."
  },
  {
    icon: "Cpu",
    title: "Innovation Continue",
    description: "Technologie Super Resolution AI Tracking de dernière génération pour une précision de comptage et de classification inégalée."
  },
  {
    icon: "HeartHandshake",
    title: "Support Local",
    description: "Smart Systems Paraguay SA vous accompagne avec un support technique local, des formations et un service après-vente de proximité."
  }
];
